import { UploadFile } from "@king-ict/eupisi-ui/models/UploadFile/UploadFile";

import { Address } from "../Shared";
import { Request } from "./Request";
import { Attachment } from "../Shared/Attachment";

export interface EnrollmentDecision {
  id: number;
  requestId: number;
  solutionId?: EnrollmentDecisionSolution;
  conclusionId?: EnrollmentDecisionConclusion;
  classification?: string;
  associationNumber?: string;
  dateOfIssue?: Date;
  dateOfDelivery?: Date;

  institutionId?: number;

  request?: Request;

  uploadFiles?: UploadFile[];
  attachments?: Attachment[];
  form7Attachment?: Attachment;
  attachment?: Attachment;
}

export enum EnrollmentDecisionSolution {
  /// <summary>
  /// Odobrava se prijevremeni upis u prvi razred osnovne škole
  /// </summary>
  EarlyEnrollmentApproved = 1,
  /// <summary>
  /// Odbija se prijevremeni upis u prvi razred osnovne škole
  /// </summary>
  EarlyEnrollmentRejected,
  /// <summary>
  /// Odgoda upisa u prvi razred osnovne škole
  /// </summary>
  EnrollmentPostponement,
  /// <summary>
  /// Odobrava se privremeno oslobađanje od upisa u prvi razred osnovne škole
  /// </summary>
  TemporaryExemptionApproved,
  /// <summary>
  /// Odbija se privremeno oslobađanje od upisa u prvi razred osnovne škole
  /// </summary>
  TemporaryExemptionRejected,
  /// <summary>
  /// Primjereni program osnovnog obrazovanja za učenike s teškoćama u razvoju
  /// </summary>
  AppropriateProgram,
}

export enum EnrollmentDecisionConclusion {
  /// <summary>
  /// Odbija se mišljenje s prijedlogom i odobrava se redovan upis
  /// </summary>
  RegularEnrollmentApprovedProposalRejected = 1,
}
